<div class="row title">
	<h3 class="heading_style mt-1 ml-3">Dashboard / <span>Apartments Data</span></h3>
	<p class="add" [routerLink]="['/apartment-add']"><i class="fa fa-plus search_icon" aria-hidden="true"></i></p>
	<div  class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
		<div class="ss-searchbox search_box" style="margin-top: -2px;">
			<i class="fa fa-search"></i>
			<input class="form-control "  style="background-color: #ECF0F1;" name="search" type="text" placeholder="Type Apartment Name, State, City, Pincode, UNID to Search" [(ngModel)]="searchstring" (keydown.enter)="getap('')">
	  </div>
		</div>
</div>


<div class="rk-ui-notification" style="z-index: 4444 !important" *ngIf="successalert">
	<span id="notificationMessageText">{{ successMessage }}</span>
	<a class="close rk-linknotification" (click)="successalert = false">×</a>
  </div>
  <div class="rk-ui-notification err" style="z-index: 4444 !important" *ngIf="erroralert">
	<span id="notificationMessageText">{{ errorMessage }}</span>
	<a class="close rk-linknotification" (click)="erroralert = false">×</a>
  </div>

  <div class="row pt-top justify-content-center">
	<div class="col-12 table-responsive p-0 d-flex justify-content-center" id="scrollTop">
	   <table class="w-96">
		  <thead>
				 <tr class="head_row p-2">
					
					 <th class="text-center br-radious  "><span class=" br-right d-inline-block w-100 pt-2 ">S No</span></th>
					 <th class="text-center "><span class="br-right d-inline-block w-100 pt-2 ">Name </span>  </th>
					 <th class="text-center "> <span class="br-right d-inline-block w-100 pt-2 ">City </span> </th>
					 <th class="text-center "><span class="br-right d-inline-block w-100 pt-2 ">UNID </span>  </th>
				 
					 <th class="table_img_col text-center "><span class="br-right d-inline-block w-100 pt-2 "> Image  </span>  </th>
					 <th class="text-center br-radious2 "> <span class="d-inline-block pb-2 w-100 pt-2 ">Actions </span></th>
				 </tr>
			 </thead>
			 <tbody>
			
					<tr class="love"
						*ngFor="let data of apartments |  paginate: {itemsPerPage:per_page , currentPage:current_page ,totalItems: total_page}; let i=index">
						<td class=" br-radious pt-3 pb-3  text-center pl-2"><span class=" br-righttd align-items-center  d-flex justify-content-center w-100 pt-2 ">
								{{current_page*10+i+1-10}} </span></td>
						<td class="text-center pt-3 pb-3 "><span class=" br-righttd align-items-center  d-flex justify-content-center w-100 pt-2 ">
								{{data.attributes.apartment_name | titlecase}} </span></td>
						<td class="text-center pt-3 pb-3 "> <span class="br-righttd align-items-center  d-flex justify-content-center w-100 pt-2 "> {{data.attributes.city |
								titlecase}} </span> </td>
						<td class="text-center pt-3 pb-3 ">
							<span class=" br-righttd align-items-center  d-flex justify-content-center w-100 pt-2 "> {{data.attributes.unid}} </span>
						</td>
					
						<td class="text-center pt-3 pb-3 "> <span class=" br-righttd align-items-center  d-flex justify-content-center w-100 pt-2 "> <img class="my-2 image-src"
									src="{{data.attributes.primary_image}}" onerror="src='../../../assets/img/default-apartment.png'"
									width="200px" *ngIf="data.attachment_file !='/images/original/missing.png' "><img
									src="../../../../assets/v3/img/noimgicon.jpeg" height="240px" width="260px"
									*ngIf="data.attachment_file =='/images/original/missing.png'"> </span> </td>
						<td class="text-center pt-3 pb-3 fa_icons  br-radious2">
							<div class="text-center w-100 pop" data-trigger="hover"  
							[attr.data-content]="data.attributes.is_enabled?'Visible - Yes':'Visible - No'" (mouseenter)="openpopup($event)">
								<label class="switch " >
									<input type="checkbox" [checked]="data.attributes.is_enabled"  (change)="toggle_button($event,data.id)" >
									<span class="slider mt-2 round"></span>
									</label>
							</div>
							
							<span class=" d-inline-block justify-content-center pt-2 w-100 "> <a
									class="" data-toggle="modal" data-target="#exampleModalLong2"
									(click)="getapartment(data.attributes.unid)"><i data-toggle="tooltip" title="Edit" data-placement="top"
										class="fa fa-pencil-square-o" aria-hidden="true"></i></a> <br> <a
									(click)="confirmAndDelete(data.attributes.unid)"><i data-toggle="tooltip" title="Delete"
										data-placement="top" class="fa fa-trash mt-4" aria-hidden="true"></i></a>
								<div class="alert alert-warning my-2" *ngIf="(data.attributes.primary_image/1024) > 120">
									<strong>Warning!</strong> Image size exceeds 120kb. </div>
							</span>
						</td>
					</tr>

				
				 
			 </tbody>
	   </table>
	   
	</div>
 
	<pagination-controls  autoHide="true" (pageChange)="current_page = getap($event)" class="float-right mt-4 d-inline-block"></pagination-controls>
 </div>

 <div class="modal fade" id="exampleModalLong2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<form [formGroup]="updateApartmentForm" (ngSubmit)="onSubmit2(updateApartmentForm.value); updateApartmentForm.reset();" class="form-horizontal">
				<!-- <fieldset formArrayName="apa"> -->
				 <div class="modal-header">

					 <h5 class="modal-title" id="exampleModalLongTitle">    <img class="cursor-pointer" (click)="closemodal()" src="../../../../assets/img/arrow_left.svg" style="width: 15px"> <span class="ml-4"> Update Apartment Details </span></h5>
					
				 </div>
				<div class="row">
				   <!--For Apartment Name-->   
				   <div class="col-md-6">
					<div class="form-group label-floating" >
					   <label class="Label_style">Apartment Name<span class="astric">*</span></label>
					   <div (mouseleave)="hideOptions()" (mouseenter)="showOptions()">					  
					   <input type="text" min=0 class="form-control text_box_style" placeholder="Enter Apartment Name" (keyup)="searchSocietyApi($event)" formControlName="apartment_name">
					   <ul  class="adressSelect" *ngIf="updateApartmentForm.controls['apartment_name'].value && updateApartmentForm.controls['apartment_name'].value != '' && isApifired " >
						<li *ngFor="let option of filteredOptions " (click)="selectOption(option)"><span class="d-inline-block h-100"><i class="fa fa-map-marker pr-1" aria-hidden="true" style="
						  font-size: 22px;vertical-align: middle; "></i></span> <span class="d-inline-block ml-1">{{ option.apartment_name }} {{ option.address }}</span>
						  </li>
						  <li *ngIf="!isSelected"   >
							<span class="d-inline-block h-100">
							<i class="fa fa-map-marker pr-1" aria-hidden="true" style="
						  font-size: 22px;vertical-align: middle; "></i></span> <span class="d-inline-block ml-1"> Could not find your property? <br>
						   <button class="btn-pink px-3 py-2 mt-2" style="border-radius: 20px;border: solid;" (click)="selectOption('other')"> Add Property Details</button></span>
						  </li>
					  </ul>
					   </div>
					</div>
				 </div>
				 <!--For Cluster-->   
				 <div class="col-md-6">
					<div class="form-group label-floating" >
					   <label class="Label_style">Cluster</label>
					   <input type="text" min=0 class="text_box_style form-control" placeholder="Enter Cluster"  formControlName="cluster">
					</div>
				 </div>
				 <!--For Apartment Address--> 
				 <div class="d-flex  w-100">

				  <div class="col-md-6">
					 <div class="form-group label-floating" >
						<label class="Label_style">Apartment Addess<span class="astric">*</span></label>
						<textarea  class=" form-control textarea_style" disabled rows="6" cols="50" placeholder=" Enter Apartment Addess " formControlName="apartment_address" >
						
					  </textarea>
					 </div>
				  </div>
				  <div class="col-md-6">
					 <div class="form-group label-floating" >
						<label class="Label_style">Pin Code<span class="astric">*</span></label>
						<input type="number" disabled min=0 class="text_box_style form-control" placeholder="Enter Pin Code"  formControlName="pincode" onKeyPress="if(this.value.length==6) return false;" pattern="[0-9]{6}">
					 </div>

					 <div class="form-group label-floating" >
						<label class="Label_style">UNID<span class="astric">*</span></label>
						<input type="text" min=0 class="text_box_style text-upper form-control" placeholder="Enter UNID"  formControlName="unid" onKeyPress="if(this.value.length==15) return false;"  readonly>
						
					 </div>



				  </div>

				 </div>  
				
				 <!-- For Pin Code-->  
			   
				 <!--Select City-->
				 <div class="col-md-6">
					<div class="form-group label-floating">
					   <label class="Label_style">Search For State<span class="astric">*</span></label>
					   <input type="text" class="text_box_style form-control" disabled formControlName="state">

					   <!-- <ng-select
					   placeholder="Search For State"
					   class=" "
					   formControlName="state"
					   (change)="getscityList($event)">
					   <ng-option *ngFor="let state of states" [value]="state.state_code">{{
					   state.name | titlecase
					   }}</ng-option>
					   </ng-select> -->
					</div>
				 </div>
				 <!--Select City-->
				 <div class="col-md-6">
					<div class="form-group label-floating">
					   <label class="Label_style">Search For City<span class="astric">*</span></label>
					   <input type="text" class="text_box_style form-control" disabled formControlName="city">

					   <!-- <ng-select
						  placeholder="Search For City"
						  class=" "
						  formControlName="city">
						  <ng-option *ngFor="let city of city_list" [value]="city">{{
						  city | titlecase
						  }}</ng-option>
					   </ng-select> -->
					</div>
				 </div>
				 <!--UNID-->
				
				
				 <!--Area Name-->
				 <div class="col-md-6">
					<div class="form-group label-floating" >
					   <label class="Label_style">Area Name<span class="astric">*</span></label>
					   <input type="text" min=0 class="text_box_style form-control" placeholder="Enter Area"  formControlName="area_name">
					</div>
				 </div>
				 <!--Select Lifestage-->
				 <div class="col-md-6">
					<div class="form-group label-floating" >
					   <label class="Label_style">Lifestage<span class="astric">*</span></label>
					   <select class="text_box_style form-control text-capitalize" formControlName="lifestage">
						  <option value=""  disabled  selected>Select Lifestage</option>
						  <option class="text-capitalize" *ngFor="let v of lifeStage" value="{{v}}">{{v}}</option>
					   </select>
					</div>
				 </div>
				 <!--Select Theme-->
				 <div class="col-md-6">
					<div class="form-group label-floating" >
					   <label class="Label_style">Theme<span class="astric">*</span></label>
					   <select class="text_box_style form-control text-capitalize" formControlName="theme">
						  <option value=""  disabled  selected>Select Theme</option>
						  <option class="text-capitalize" *ngFor="let v of theme" value="{{v}}">{{v}}</option>
					   </select>
					</div>
				 </div>
				 <!--Developer Name-->
				 <div class="col-md-6">
					<div class="form-group label-floating" >
					   <label class="Label_style">Developer Name<span class="astric">*</span></label>
					   <input type="text" min=0 class="text_box_style form-control" placeholder="Enter Developer Name"  formControlName="developer_name">
					</div>
				 </div>
				 <div class="col-md-3">
					<div class="form-group label-floating">
					   <label class="Label_style">Start From<span class="astric">*</span></label>
					   <input type="number" min=0 class="text_box_style form-control" placeholder="Enter Start From" formControlName="start_from">
					</div>
				 </div>
				 <div class="col-md-3">
					<div class="form-group label-floating">
					   <label class="Label_style">Apartment Value<span class="astric">*</span></label>
					   <input type="number" min=0 class="text_box_style form-control" placeholder="Enter Apartment Value" formControlName="apartment_value">
					</div>
				 </div>
				 <div class="col-md-3">
					<div class="form-group label-floating">
					   <label class="Label_style">Apartment Area<span class="astric">*</span></label>
					   <input type="number" min=0 class="text_box_style form-control" placeholder="Enter Apartment Area" formControlName="area">
					</div>
				 </div>


				 <div class="col-md-3">
					<div class="form-group label-floating">
					   <label class="Label_style">BOQ EMI<span class="astric">*</span></label>
					   <input type="number" min=0 class="text_box_style form-control" placeholder="Enter EMI" formControlName="boq_emi">
					</div>
				 </div>
				
				  
				   <!--Format with varient id and layout image-->
				   <div class="col-md-12">
			  <div class="col-md-12">
				   <fieldset formArrayName="formats"
					  >
					  <div class="row mt-3" *ngFor="let item of updateApartmentForm.get('formats')['controls']; let i = index;" [formGroup]="item">
						<div class="card ml-3 w-100 format_con p-4" >
						 <div class="container-fluid">
							<!--Select Format-->      
							<div class="col-md-4 mt-3">
							   <div class="form-group label-floating" >
								  <label class="Label_style" >Select Format<span class="astric">*</span></label>
								  <select *ngIf="showValidator(i)=='show'" class="form-control  text_box_style text-capitalize" formControlName="name">
									 <option value=""  disabled  selected>Select Format</option>
									 <option class="text-capitalize" *ngFor="let v of formatData" value="{{v}}">{{v}}</option>
								  </select>
								  <select *ngIf="showValidator(i)=='hide'" disabled class="form-control  text_box_style text-capitalize" formControlName="name">
									<option value="" selected>Select Format</option>
									<option class="text-capitalize" *ngFor="let v of formatData" value="{{v}}">{{v}}</option>
								 </select>
							   </div>
							</div>
							<!--Select Format Ends Here-->
							<!--Variant Data Format-->
							<div class="col-md-12">
							    <div class="card mb-3 varient_con mt-4 w-100 p-4" >
								  <div class="container-fluid">
									 <fieldset formArrayName="variants">
										<div class="row pb-3 pt-3" *ngFor="let player of item.get('variants')['controls']; let j = index;" [formGroup]="player">
										<div class="col-md-8">
										   <div class="form-group label-floating" >
											  <label class="Label_style">Variant ID<span class="astric">*</span></label>
											  <input type="text" min=0 class="form-control w-50   text_box_style" [readonly]="VarientsIdForCheck.indexOf(item.get('variants').controls[j].controls['id'].value) != -1" placeholder="Enter Variant ID"  formControlName="variant_id" onKeyPress="if(this.value.length==6) return false;">
										   </div>
										</div>

											<!-- <div class="col-md-6">
										   <div class="form-group label-floating">
											  <label class="Label_style">Select Layout Floor  Plannn<span class="astric">*</span></label>
											  <input type="file" (change)="onChange($event,i,j)" class="form-control  text_box_style border-0" [attr.id]="'attachment_file'+i+j" name="attachment_file" hidden >
											   
											  <div class="col-md-12 uploadStyle">
												<div class="col-md-7 imgStyle"> {{item.get('variants').controls[j].controls['layout_imgagefilename'].value?item.get('variants').controls[j].controls['layout_imgagefilename'].value : 'Upload Image'}}</div>
												<div class="col-md-4 uploadBtn">
												   <label class="labelStyle2" for="{{'attachment_file'+i+j}}">Uploadddd</label>
												</div>
																								
											
										   </div>
										   <img class="image" *ngIf="item.get('variants').controls[j].controls['layout_image'].value !=''" src ="{{item.get('variants').controls[j].controls['layout_image'].value}}" onerror="src='../../../assets/img/default-apartment.png'" width="200" height="200" >
										   </div>
										</div> -->



										<!-- <div class="col-md-6">
										   <div class="form-group label-floating">
											  <label class="Label_style">Select Primary Imageee<span class="astric">*</span></label>
											  <input type="file" src="{{item.get('variants').controls[j].controls['primary_image'].value}}" [attr.id]="'attachment_file2'+i+j"  (change)="onChangeImage($event,i,j)" class="form-control  text_box_style border-0" name="attachment_file" hidden >
											  <div class="col-md-12 uploadStyle">
												<div class="col-md-7 imgStyle"> {{item.get('variants').controls[j].controls['primary_imagefilename'].value?item.get('variants').controls[j].controls['primary_imagefilename'].value : 'Upload Image'}}</div>
												<div class="col-md-4 uploadBtn">
												   <label class="labelStyle2" for="{{'attachment_file2'+i+j}}">Uploaddddd</label>
												</div>
											  </div>

												<img *ngIf="item.get('variants').controls[j].controls['primary_image'].value !=''" class="image"  src ="{{item.get('variants').controls[j].controls['primary_image'].value}}" onerror="src='../../../assets/img/default-apartment.png'" width="200" height="200" >
										   </div>
										</div> -->

										<!-- select layout floor plan -->
										<div class="col-md-6">
											<label class="mb-2 Label_style">Select Layout Floor Plan<span class="astric">*</span></label>
											<div class="input-group">
											  <input id="fileNamePresettwoupdate{{i}}{{j}}"   class="form-control preset-zip-file-upload" readonly (click)="filePickerlayout.click()"    aria-label="Recipient's username" aria-describedby="basic-addon2" style="background-color: white;">
											  <div class="input-group-append">
											   <button class="btn cursor-pointer btn-burgntee px-5 font-weight-bold choose-file-btn" (click)="filePickerlayout.click()" type="button">Upload</button>
											  </div>
											  <input  #filePickerlayout (change)="onChange($event,i,j)" type="file"   class="form-control-file d-none" >
											</div>
											<img class="image" *ngIf="item.get('variants').controls[j].controls['layout_image'].value !=''" src ="{{item.get('variants').controls[j].controls['layout_image'].value}}" onerror="src='../../../assets/img/default-apartment.png'" width="200" height="200" >
										 </div>



									

										<!-- select primary image -->
										<div class="col-md-6">
											<label class="mb-2 Label_style ">Select Primary Image<span class="astric">*</span></label>
											<div class="input-group">
											  <input id="fileNamePresetoneupdate{{i}}{{j}}"   class="form-control preset-zip-file-upload" readonly (click)="filePickeroneupdate.click()"  aria-label="Recipient's username" aria-describedby="basic-addon2" style="background-color: white;">
											  <div class="input-group-append">
											   <button class="btn cursor-pointer btn-burgntee px-5 font-weight-bold choose-file-btn" (click)="filePickeroneupdate.click()" type="button">Upload</button>
											  </div>
											  <input  #filePickeroneupdate (change)="onChangeImage($event,i,j)" type="file"   class="form-control-file d-none" >
											</div>
											<img *ngIf="item.get('variants').controls[j].controls['primary_image'].value !=''" class="image"  src ="{{item.get('variants').controls[j].controls['primary_image'].value}}" onerror="src='../../../assets/img/default-apartment.png'" width="200" height="200" >
										</div>

										<div class="col-md-4">
										   <div class="form-group label-floating" >
											  <label class="Label_style">VR Link</label>
											  <input type="text" min=0 class="form-control  text_box_style" placeholder="Enter VR Link"  formControlName="vr_link" >
										   </div>
										</div>
										
										<div class="col-sm-12">
											<p *ngIf="VarientsToDelete.indexOf(item.get('variants').controls[j].controls['id'].value) != -1" class="remove_style">Selected To Delete </p> <span *ngIf="VarientsToDelete.indexOf(item.get('variants').controls[j].controls['id'].value) != -1" class="text-info" (click)="Unselect(item.get('variants').controls[j].controls['id'].value)"> <i class="fa fa-minus-square-o" aria-hidden="true"></i> Click To Unselect</span>
										   <a class="removeIcon mt-3 remove_style" (click)="Deletevariants(item.get('variants').controls[j].controls['id'].value,item,i,j);" *ngIf="item.get('variants').length > 1 && VarientsToDelete.indexOf(item.get('variants').controls[j].controls['id'].value) == -1 "><img src="../../../../assets/img/removeapr.png"> Remove  Variant</a>
									   </div>
								  </div>
								  <!-- <div class="col-sm-12">
									 <a class="removeIcon" (click)="item.get('variants').removeAt(j)"><i class="fa fa-minus-circle mr-1" aria-hidden="true">Remove Last Variant</i></a>
								 </div> -->
								  </fieldset>
							   </div>
							   <div class="w-100">
								<a (click)="addAnotherVariant(item)" class="addIcon varient-add mt-3"><i class="fa fa-plus plus_style " aria-hidden="true"></i></a> <a (click)="addAnotherVariant(item)" class="styling_remove_format">Add Another Variant</a>
							   </div>
							</div>
						 </div>
						
						 <!--Variant Data Format Ends Here-->
						 <!-- <div class="col-sm-12">
							<i class="fa fa-minus-circle remove_button" (click)="item.get('variants').removeAt(j)"></i>
						</div> -->
						
					  </div>
				</div>
				<div class="col-sm-12 mt-3">
				   <a class="removeIcon mt-3 remove_style" *ngIf="updateApartmentForm.get('formats').length > 1 " (click)="RemoveValidator(i)"><img src="../../../../assets/img/removeapr.png"> Remove  Format</a>
				  			   </div>
			 </div>
			 <!-- <div class="col-sm-12">
				<a class="removeIcon" (click)="updateApartmentForm.get('format').removeAt(i)"><i class="fa fa-minus-circle mr-1" aria-hidden="true"></i>Remove Last Format</a>
			</div> -->
			 </fieldset>
		  </div>
			</div>
			<!--Format with varient id and layout image ends here-->
			<a (click)="pushJobAttributesup(updateApartmentForm)" class="addIcon plus_style ml-4 mt-3"> <i class="fa fa-plus plus_style " aria-hidden="true"></i> </a> <a (click)="pushJobAttributesup(updateApartmentForm)" class="styling_remove_format ml-1 mt-4"> Add Another Format</a>
		  </div>
		  <div class="d-flex w-100 justify-content-center">
			<button type="submit" [disabled]="!updateApartmentForm.valid" class="button submit-btn">Update</button>  
		  </div>
		 
		  </form>	 
 </div>
</div>
</div>

<div id="OtherProjectname" class="modal" role="dialog" data-backdrop="static">
	<div class="modal-dialog modal-dialog-centered leadQUES"  style="max-width: 50rem !important;margin-left: auto;margin-right: auto;"  >
	  <!-- Modal content-->
	  <div style="border: 3px solid #6F0000;" class="modal-content p-1">
		<div class="modal-header">
		  <h6 class="modal-title w-100 text-center"> Add Society/Building/Project </h6>
		  <button (click)="closeaddApartmentrplanModal()" type="button" class="close"><i class="fa fa-close"></i></button>
		
		</div>
		<div class="modal-body " (mouseover)="pincodeval()">
		  <div class="col-12 row">
			<div  class="form-check d-flex col-12 "  >
			  <label   class="customLabel mt-2 col-6">Society/Building/Project Name :<span
				class="text-danger hideAsteriskIcon">*</span></label>
			  <input  type="text"  class="form-control col-6" [(ngModel)]="projectName"
				placeholder="Enter the Project name">
			</div>
			<div  class="form-check  d-flex col-12"  >
			  <label   class="customLabel mt-2 col-6 ">Developer Name :<span
				class="text-danger hideAsteriskIcon">*</span></label>
			  <input type="text"   class="form-control col-6"
				placeholder="Enter the Developer name" [(ngModel)]="DeveloperName">
			</div>
			<div  class="form-check d-flex col-12"  >
			  <label   class="customLabel mt-2  col-6">Full Address :<span
				class="text-danger hideAsteriskIcon">*</span></label>
				<input  id="autocomplete-input"  type="text"  class="form-control"    [(ngModel)]="FullAdress" (focus)="pincodeval()" (change)="pincodeval()"
				placeholder="Enter the Full Address">
			 
			</div>
			<div  class="form-check  d-flex col-12"  >
			  <label   class="customLabel mt-2 col-6">City :<span
				class="text-danger ">*</span></label>
			  <input id="citygoogle"  readonly type="text"  class="form-control col-6" >
			</div>
			
			<div  class="form-check d-flex col-12"  >
			  <label   class="customLabel mt-2 col-6">Pincode :<span
				class="text-danger ">*</span></label>
			  <input id="pincodegoogle"  type="text"   class="form-control col-6"
				 >
				 <input id="areaname" readonly type="text"   class="form-control d-none col-6"
				 >
				 <input id="state" readonly type="text"   class="form-control d-none col-6"
				 >
			</div>
		  </div>
		  <div class="col-12 mt-2 d-flex justify-content-center">
  
			<button class="btn btn-pink px-3 py-2" [disabled]="projectName == '' || DeveloperName == '' ||  FullAdress == '' || pincodePro == ''   " (click)="Submitapart()">Submit</button>
  
		  </div>
		</div>
	  </div>
	</div>
  </div>
  


 


// WEBPACK FOOTER //
// ./src/app/platform/organisation/add-apartment/add-apartment.component.html